import { Component, DOCUMENT, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, RouterModule } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AppModule } from "./app.module";
import { bootstrapApplication } from "@angular/platform-browser";
import { RealtimeService } from "./shared/services/realtime.service";
import { environment } from "../environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [RouterModule],
})
export class AppComponent {
  title = "brosh-web";
  // non-prod builds get a visible environment marker (ribbon, tab title, favicon)
  envLabel = environment.env === "prod" ? null : environment.env.toUpperCase();

  private titleService = inject(Title);
  private document = inject(DOCUMENT);
  // Instantiated here so the live connection follows sign-in from the start.
  private realtime = inject(RealtimeService);

  constructor(
    private router: Router,
    public translateService: TranslateService
  ) {
    this.translateService.setDefaultLang("he");
    this.translateService.use("he");
    if (this.envLabel) this.markEnvironment();
  }

  ngOnInit() {
    this.router.navigate([""]);
  }

  private markEnvironment() {
    this.titleService.setTitle(`[${this.envLabel}] ${this.titleService.getTitle()}`);
    this.document.querySelectorAll<HTMLLinkElement>("link[rel~='icon']").forEach((link) => {
      link.type = "image/svg+xml";
      link.href = "assets/favicon-qa.svg";
    });
  }
}
